var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFloat3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1535_985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 194.82H97.42C97.42 168.985 107.683 144.209 125.951 125.941C144.219 107.673 168.995 97.41 194.83 97.41V0C87.23 0 0 87.23 0 194.82Z",
    fill: "#FFE400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1535_985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194.83,
    height: 194.83,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloat3);
export default __webpack_public_path__ + "static/media/float-3.2f5649eeb71e262e23cabefd20aef15d.svg";
export { ForwardRef as ReactComponent };